import React from 'react';
import { svg } from '@peachjar/components';
import { css, cx } from 'react-emotion';
import AccountSection from './AccountSection';

const ToolBar = ({ isAuthenticated, logout, email, image }) => (
  <div
    className={cx(classNames.toolbar, 'layout-row layout-align-center-center')}
  >
    <div className={classNames.logoContainer}>
      <svg.PeachjarLogo />
    </div>
    {isAuthenticated && <AccountSection email={email} logout={logout} image={image} />}
    {/* <elements.CallUs /> */}
  </div>
);

const classNames = {
  toolbar: css`
    height: 100%;
    width: 100%;
  `,
  logoContainer: css`
    width: 120px;
    height: 38px;
    display: flex;
    flex: 1 1 auto;
  `,
};

export default ToolBar;



// WEBPACK FOOTER //
// ./src/_app/components/BrandBar/components/ToolBar.jsx